import React from 'react';
import { Box, CoveragePeriods, Hint, InfoOutlineIcon, Inscription } from '@common-fe/common-fe';
import styled from 'styled-components';

const StyledInfoIcon = styled(InfoOutlineIcon)`
  &:hover {
    fill: ${({ theme }) => theme.colors.iconAccent};
  }
  transition: fill 0.3s;
`;

export interface LimitedPeriods {
  limitedPeriodStart?: string;
  limitedPeriodEnd?: string;
}
interface Props {
  limitedPeriods?: LimitedPeriods[];
  externalDeductibleMet?: string;
  coveragePeriods?: CoveragePeriods[];
}

export const EnrollmentCoverageInfoHint: React.FC<Props> = ({
  limitedPeriods,
  externalDeductibleMet,
  coveragePeriods,
}) => {
  return (
    <Hint
      hintAlign="right"
      hintWidth={184}
      hintElement={<StyledInfoIcon color="iconSecondary" size="16px" />}
    >
      <Box data-testid="EnrollmentCoverageInfoHint_content" justify="center">
        {limitedPeriods && limitedPeriods.length ? (
          <Inscription size="12px" weight={700} margin={{ bottom: 'spacing2' }}>
            Limited periods:
          </Inscription>
        ) : null}
        {limitedPeriods?.map((period) => (
          <Box key={period.limitedPeriodStart} gap="spacing2" direction="row">
            <Inscription
              data-testid="EnrollmentCoverageInfoHint_limited-period-start"
              size="12px"
              weight={500}
            >
              {period.limitedPeriodStart ? `${period.limitedPeriodStart} - ` : ''}
            </Inscription>
            <Inscription data-testid="EnrollmentCoverageInfoHint_limited-period-end" size="12px" weight={500}>
              {period.limitedPeriodEnd
                ? period.limitedPeriodEnd
                : coveragePeriods?.[0]?.endDate || 'No deadline'}
            </Inscription>
          </Box>
        ))}
        {externalDeductibleMet ? (
          <Box gap="spacing2" margin={{ top: 'spacing8' }}>
            <Inscription size="12px" weight={700}>
              External deductible met:
            </Inscription>
            <Inscription size="12px" weight={500}>
              {externalDeductibleMet}
            </Inscription>
          </Box>
        ) : null}
      </Box>
    </Hint>
  );
};
